import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
//import { FaSave } from "react-icons/fa"; // Importa el icono de guardar

const Auditoria = () => {
  const [eventos, setEventos] = useState([]);
  const [lideres, setLideres] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const [eventoSeleccionado, setEventoSeleccionado] = useState("");
  const [liderSeleccionado, setLiderSeleccionado] = useState("");
  const [eventoInfo, setEventoInfo] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [estatusComentarios, setEstatusComentarios] = useState({});

  //  Obtener eventos al cargar la página
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Eventos/ListaEventos`);
        setEventos(response.data);
      } catch (error) {
        console.error("❌ Error al obtener eventos:", error);
      }
    };
    fetchEventos();
  }, []);

  //  Obtener líderes y detalles del evento
  const handleEventoChange = async (e) => {
    const eventoId = Number(e.target.value);
    if (!eventoId) return;

    setEventoSeleccionado(eventoId);
    setLiderSeleccionado("");
    setParticipantes([]);
    setEstatusComentarios({});

    try {
      const lideresResponse = await axios.get(`${API_BASE_URL}/Eventos/AuditoriaLideresPorEvento`, {
        params: { eventoId },
      });

      const eventoResponse = eventos.find(evento => evento.id === eventoId);

      setLideres(lideresResponse.data);
      setEventoInfo(eventoResponse);
    } catch (error) {
      console.error("❌ Error al obtener información:", error);
      setLideres([]);
      setEventoInfo(null);
    }
  };


const handleLiderChange = async (e) => {
    const liderId = e.target.value; //  Enviar ID en lugar del usuario
    if (!liderId) return;

    setLiderSeleccionado(liderId);

    try {
        console.log(`📢 Enviando liderId: ${liderId}`);

        const response = await axios.get(`${API_BASE_URL}/Eventos/ParticipantesPorLiderEvento`, {
            params: { eventoId: eventoSeleccionado, liderId } //  Enviar el ID del líder
        });

        console.log("✅ Respuesta recibida:", response.data);
        setParticipantes(response.data);

        //  Cargar valores actuales de estatus y comentario desde la API
        const nuevosEstatus = {};
        response.data.forEach((p) => {
            nuevosEstatus[p.id] = {
                estatus: p.estatus || "pendiente",
                comentario: p.comentario || "",
            };
        });

        setEstatusComentarios(nuevosEstatus);

    } catch (error) {
        console.error("❌ Error al obtener participantes:", error);
        setParticipantes([]);
    }
};



  //  Actualizar estado de estatus y comentario por cada participante
  const handleEstatusComentarioChange = (id, field, value) => {
    setEstatusComentarios((prevState) => ({
      ...prevState,
      [id]: { ...prevState[id], [field]: value },
    }));
  };

  //  Guardar Estatus y Comentario
  const actualizarEstatusComentario = async (id) => {
    if (!id) return;

    const { estatus = "Pendiente", comentario = "" } = estatusComentarios[id] || {};

    console.log(" Enviando datos a la API:", { id, estatus, comentario });

    try {
        const response = await axios.post(`${API_BASE_URL}/Eventos/ActualizarEstatusComentario`, null, {
            params: { id, estatus, comentario }
        });

        alert(response.data.message);
        console.log(" Datos enviados correctamente:", response.data);
    } catch (error) {
        console.error(" Error al actualizar estatus/comentario:", error.response?.data || error);
        alert("Hubo un error al actualizar los datos.");
    }
};


  return (
    <div className="wrapper">
      <div className="form-box">
      <img src="/img/monytorlogoa.png" alt="ImageLogin" className="login-image" />
        <h2 className="text-white">Auditoría</h2>

        {/*  Selección de evento */}
        <label className="block text-gray-400 text-sm">Selecciona un Evento</label>
        <select className="w-full p-2 border border-gray-600 rounded text-white bg-gray-800"
          value={eventoSeleccionado} onChange={handleEventoChange}>
          <option value="">-- Seleccionar Evento --</option>
          {eventos.map((evento) => (
            <option key={evento.id} value={evento.id}>{evento.nombreEvento}</option>
          ))}
        </select>

        {/*  Selección de líder */}
        {eventoSeleccionado && (
          <>
            <label className="block text-gray-400 text-sm mt-4">Selecciona un Líder</label>
            <select className="w-full p-2 border border-gray-600 rounded text-white bg-gray-800"
              value={liderSeleccionado} onChange={handleLiderChange}>
              <option value="">-- Seleccionar Líder --</option>
              {lideres.map((lider) => (
                <option key={lider.id} value={lider.id}>{lider.nombre} ({lider.usuario})</option>
              ))}
            </select>
          </>
        )}

        {/*  Mostrar detalles del evento */}
        {eventoInfo && (
          <div className="mt-6 bg-[#081b29] p-4 rounded-lg border border-gray-700 text-white shadow-md">
            <h3 className="text-lg font-semibold mb-2 text-center">Detalles del Evento</h3>
            <table className="w-full text-sm">
              <tbody>
                <tr><td>Nombre:</td><td>{eventoInfo.nombreEvento}</td></tr>
                <tr><td>Fecha Inicio:</td><td>{eventoInfo.fechaInicio}</td></tr>
                <tr><td>Fecha Fin:</td><td>{eventoInfo.fechaFin}</td></tr>
                <tr><td>Estatus:</td><td>{eventoInfo.estatusEvento}</td></tr>
                <tr><td>Meta:</td><td>{eventoInfo.meta || "Sin meta"}</td></tr>
                <tr><td>Descripción:</td><td>{eventoInfo.descripcionEvento || "Sin descripción"}</td></tr>
              </tbody>
            </table>
          </div>
        )}

        {/*  Tabla de Participantes */}
        {liderSeleccionado && participantes.length > 0 && (
            <div className="mt-6">
                <h3 className="text-lg font-semibold mb-4 text-white">Participantes Registrados</h3>
                <table className="min-w-full bg-[#081b29] border border-gray-700 rounded-lg text-white">
                    <thead>
                        <tr className="bg-[#0f283a] text-white">
                            <th>Nombre</th>
                            <th>Evidencia</th>
                            <th>Estatus</th>
                            <th>Comentario</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                    {/* {participantes.map((p) => (
                            <tr key={p.id} className="text-center border border-gray-700 bg-[#0d2533] hover:bg-[#12394d] transition">
                                <td>{p.nombres} {p.apellidos}</td>
                                <td>
                                    {p.evidencia1 ? (
                                        <button className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition"
                                            onClick={() => setPdfUrl(`${API_BASE_URL}${p.evidencia1}`)}>
                                            Ver PDF
                                        </button>
                                    ) : "Sin evidencia"}
                                </td>
                                <td>
                                    <select className="border p-1 rounded bg-[#0f283a] text-white"
                                        value={estatusComentarios[p.id]?.estatus || "pendiente"}
                                        onChange={(e) => handleEstatusComentarioChange(p.id, "estatus", e.target.value)}>
                                        <option value="pendiente">Pendiente</option>
                                        <option value="aprobado">Aprobado</option>
                                        <option value="rechazado">Rechazado</option>
                                    </select>
                                </td>
                                <td>
                                    <input type="text" className="border p-1 rounded w-full bg-[#0f283a] text-white"
                                        value={estatusComentarios[p.id]?.comentario || ""}
                                        onChange={(e) => handleEstatusComentarioChange(p.id, "comentario", e.target.value)} />
                                </td>
                                <td>
                                    <button onClick={() => actualizarEstatusComentario(p.id)}
                                        className="bg-green-500 text-white px-3 py-1 rounded">
                                        💾
                                    </button>
                                </td>
                            </tr>
                        ))} */}
                        {participantes.map((p) => (
                            <tr key={p.id} className="text-center border border-gray-700 bg-[#0d2533] hover:bg-[#12394d] transition">
                                <td>{p.nombres} {p.apellidos}</td>
                                <td>
                                    {p.evidencia1 ? (
                                        <button className="btn info text-white px-3 py-1 rounded hover:#081b29 transition"
                                            onClick={() => setPdfUrl(`${API_BASE_URL}/Eventos/VerEvidencia?filePath=${p.evidencia1}`)}>
                                            Ver PDF
                                        </button>
                                    ) : "Sin evidencia"}
                                </td>
                                <td>
                                    <select className="border p-1 rounded bg-[#0f283a] text-white"
                                        value={estatusComentarios[p.id]?.estatus || "pendiente"}
                                        onChange={(e) => handleEstatusComentarioChange(p.id, "estatus", e.target.value)}>
                                        <option value="pendiente">Pendiente</option>
                                        <option value="aprobado">Aprobado</option>
                                        <option value="rechazado">Rechazado</option>
                                    </select>
                                </td>
                                <td>
                                    <input type="text" className="border p-1 rounded w-full bg-[#0f283a] text-white"
                                        value={estatusComentarios[p.id]?.comentario || ""}
                                        onChange={(e) => handleEstatusComentarioChange(p.id, "comentario", e.target.value)} />
                                </td>
                                <td>
                                    <button onClick={() => actualizarEstatusComentario(p.id)}
                                        className="btn info text-white px-3 py-1 rounded">
                                        💾
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )}


        {/*  Modal para ver PDF */}
            {pdfUrl && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 p-4">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full">
                    <div className="flex justify-between items-center border-b pb-2">
                    <h3 className="text-lg font-semibold">Evidencia</h3>
                    <button onClick={() => setPdfUrl(null)} className="text-gray-600 hover:text-black text-lg">✖</button>
                    </div>
                    <iframe src={pdfUrl} className="w-full h-[500px]" title="Evidencia PDF"></iframe>
                </div>
                </div>
            )}

      </div>
    </div>
  );
};

export default Auditoria;
